import {Component, OnChanges, OnInit} from "@angular/core";
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {BsDatepickerConfig} from "ngx-bootstrap/datepicker/public_api";

@Component({
    selector: 'app-job-hold-abort-foc',
    templateUrl: 'job-hold-abort-foc.component.html',
    styleUrls: ['job-hold-abort-foc.component.css']
})

export class JobHoldAbortFocComponent implements OnInit,OnChanges {
    public onClose: Subject<boolean>;
    title:string='';
    reasons:any;
    labelType:string='';
    select2Config:any = {};
    jobForm: FormGroup;
    bsDateConfig: Partial<BsDatepickerConfig> = {};
    SelectedUsers:any;
    users:any;
    constructor(public sidePanelModalRef: BsModalRef,
                private fb: FormBuilder){}
    ngOnInit() {
        this.onClose = new Subject();
        this.select2Config = {
            width: '100%'
        }
        this.jobForm = this.fb.group({
            reason: ['', Validators.required],
        });
    }
    ngOnChanges(changes) {

    }
    onSubmit() {
        this.onClose.next(this.jobForm.value);
        this.sidePanelModalRef.hide();
    }


}
